import { DialogProps } from '@material-ui/core';
import { useCacheContext } from 'framework/hooks/useCacheContext';
import { IInventoryItem, inventoryItemsCommand_patchLabels } from 'gen/ApiClient';
import React from 'react';
import { LabelsForm } from 'shared/LabelsForm';
import { InventoryItemsFilterDataContext } from '../context/InventoryItemsFilterDataContext';

interface IProps extends DialogProps {
	item: IInventoryItem;
	cancel: VoidFunction;
	confirm: VoidFunction;
}

export const InventoryItemLabelsForm = ({ item, ...rest }: IProps) => {
	const [data] = useCacheContext(InventoryItemsFilterDataContext);

	if (data === undefined) {
		return <div></div>;
	}

	return (
		<LabelsForm
			{...rest}
			autoCompleteLabels={data.labels}
			labels={item.labels}
			updateF={values => inventoryItemsCommand_patchLabels({ inventoryItemId: item.id, labels: values })}
		/>
	);
};
